// extracted by mini-css-extract-plugin
export default {"root":"Header_root__ixWiJ","nav":"Header_nav__0Ci-Y","logo":"Header_logo__nCjsB","itemsWrapper":"Header_itemsWrapper__z5Xt7","item":"Header_item__KgoDR"};